module.exports = __webpack_public_path__ + "assets/img/testi3.de1083a3.jpg";